(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  (function(){
    /**
     * Handles toggling the search in header for small screens - adds class for better visual interactions.
     */

    let header, search, search_field;
    header = document.querySelector('.site-header');
    if (!header) return;
    search = header.querySelector('.search-form');
    if (!search) return;
    search_field = search.querySelector('.search-field');
    if (!search_field) return;

    search_field.addEventListener('focus', function (obj) {
      search.classList.add('active');
    }, true);
    search_field.addEventListener('blur', function (obj) {
      search.classList.remove('active');
    }, true);

  })();

}));
